import { SeverityBadge } from '@/components/shared/UiElements';

/**
 * FindingRow — a severity chip, a title, and a meta line.
 *
 * Spec slide 10 draws exactly that: `CRITICAL | No primary CTA above the fold |
 * Dashboard · hero · Quick fix · High impact`, rows separated by a hairline.
 *
 * ── THE CHIP CARRIES THE THREE-STEP METER, WHICH THE SLIDE DOES NOT DRAW ────
 *
 * Ruled 2026-08-17 and not reopened: severity NEVER depends on colour alone,
 * so every chip carries the meter AND the word. The slide draws the word and
 * the fill only. Reusing `SeverityBadge` rather than restyling a chip here is
 * what keeps that true in one place — a second chip implementation is a second
 * chance to drop the meter.
 *
 * ── THE META LINE IS WHATEVER THE FINDING ACTUALLY HAS ──────────────────────
 *
 * The slide's example row reads "Steps 1-4 · Moderate · Medium impact" against
 * an Onboarding finding. Onboarding is not a dimension we score, and "Steps
 * 1-4" is flow data this product does not collect from a single page. The parts
 * are filtered to the ones present, so a finding with no effort rating renders
 * a shorter line instead of an invented one.
 */
export function FindingRow({ severity, title, dimension, effort, impact, onClick, testId }) {
  const meta = [dimension, effort, impact].filter(Boolean);
  const Tag = onClick ? 'button' : 'div';
  return (
    <Tag
      className="uxa-finding-row"
      onClick={onClick}
      type={onClick ? 'button' : undefined}
      data-testid={testId || 'finding-row'}
    >
      <SeverityBadge severity={severity} />
      <span className="uxa-finding-row__body">
        <span className="uxa-finding-row__title">{title}</span>
        {meta.length ? (
          <span className="uxa-finding-row__meta">{meta.join(' · ')}</span>
        ) : null}
      </span>
    </Tag>
  );
}

export default FindingRow;
